import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaTrash, FaPlusCircle } from "react-icons/fa";

const ImageSelector = ({ initialImages = [], onImagesChange }) => {
  const [images, setImages] = useState(initialImages);

  // Send updated images to the parent component
  useEffect(() => {
    if (onImagesChange) {
      onImagesChange(images);
    }
  }, [images, onImagesChange]);

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);

    const fileReaders = files.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve({ file: file, data: reader.result });
        reader.onerror = reject;
        reader.readAsArrayBuffer(file); // Read the file as binary data
      });
    });

    Promise.all(fileReaders)
      .then((newImages) => {
        setImages((prevImages) => [...prevImages, ...newImages]);
      })
      .catch((err) => console.error("Error reading files:", err));
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <Wrapper className="px-3 py-2">
      <div className="rounded imgList d-flex align-items-center gap-2">
        <label className="img-item rounded position-relative">
          <input type="file" multiple accept="image/*" onChange={handleImageUpload} style={{ display: "none" }} />
          <FaPlusCircle className="icon" color="#000" />
        </label>
        {images.map((img, i) => (
          <div key={i} className="img-item rounded position-relative">
            <img src={URL.createObjectURL(new Blob([img.data]))} alt={`Selected ${i}`} />
            <FaTrash className="icon" color="#fff" onClick={() => handleRemoveImage(i)} />
          </div>
        ))}
      </div>
    </Wrapper>
  );
};

export default ImageSelector;

const Wrapper = styled.div`
  .imgList {
    overflow-x: auto;
    display: flex;
  }
  .imgList::-webkit-scrollbar {
    display: none;
  }
  .img-item {
    position: relative;
    border: none;
    outline: none;
    background: #eeeeee;
    height: 95px;
    width: 100px;
    color: gray;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: all ease 0.3s;
    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
    .icon {
      position: absolute;
      cursor: pointer;
      font-size: 1.5rem;
    }
  }
  .icon:hover {
    transform: scale(1.1);
  }
  p {
    margin-bottom: 0.4rem;
  }
`;
